<template>
    <v-layout wrap>

        <v-flex xs12>
            <v-text-field label="Nombre (opcional)" :value="name" v-model="name" placeholder="Ej. Agenda de verano" />
        </v-flex>
        <v-flex xs12 md6>
            <week-day-picker :disabled="lock" :value="weekDays" v-on:change="onWeekDaysChange"/>
        </v-flex>
        <v-flex xs12 md6>
            <v-select :disabled="lock" :value="intervalMinutes" v-model="intervalMinutes" :items="intervalOptions" label="Intervalos de tiempo"></v-select>
        </v-flex>
        <v-flex xs6>
            <v-select :disabled="lock" :value="intervalStart" v-model="intervalStart" :items="intervals" label="Inicio jornada"></v-select>
        </v-flex>
        <v-flex xs6>
            <v-select :disabled="lock" :value="intervalEnd" v-model="intervalEnd" :items="intervals" label="Término jornada"></v-select>
        </v-flex>
      <v-flex xs12 sm6>
        <v-select :disabled="lock" :value="appointmentAnticipationHours" v-model="appointmentAnticipationHours" :items="appointmentAnticipationOptions" label="Anticipación de la cita"></v-select>
      </v-flex>
      <v-flex xs12 sm6>
        <v-select :disabled="lock" :value="appointmentLimitDays" v-model="appointmentLimitDays" :items="appointmentLimitDaysOptions" label="Días disponibles"></v-select>
      </v-flex>

      <v-flex xs12>
        <v-alert type="error" :value="scheduleStructureChangeWarning">
          Al realizar estos cambios, se podrían eliminar las horas bloqueadas, en tal caso tendrías que configurarlas nuevamente.
        </v-alert>
        <v-alert :value="!!scheduleLengthError" type="error">
          {{scheduleLengthError}}
        </v-alert>
      </v-flex>

    </v-layout>
</template>

<script>
    import WeekDayPicker from './WeekDayPicker'
    import {mapMutations} from 'vuex'

    export default{
        props: [
            'intervalStartValue',
            'intervalEndValue',
            'intervalMinutesValue',
            'weekDaysValue',
            'nameValue',
            'isUpdate',
            'lock',
            'appointmentAnticipationHoursValue',
            'appointmentLimitDaysValue'
        ],
        components: {WeekDayPicker},
        mounted(){
            this.setDefaults()
        },
        methods: {
            ...mapMutations(['showSnackBar']),

            onWeekDaysChange(val){
                this.weekDays = val
            },
            reset(){
                var vm = this
                vm.setDefaults()
                vm.scheduleStructureChanged = false
            },
            setDefaults(){
                var vm = this
                vm.name =  vm.nameValue || ''
                vm.weekDays = vm.weekDaysValue || [1,2,3,4,5,6,0]
                vm.intervalMinutes = vm.intervalMinutesValue ? Number(vm.intervalMinutesValue) : 60
                vm.intervalStart = vm.intervalStartValue || vm.intervals && vm.intervals[0] || ''
                vm.intervalEnd = vm.intervalEndValue || vm.intervals && vm.intervals[vm.intervals.length-1] || ''
                vm.appointmentAnticipationHours = vm.appointmentAnticipationHoursValue ? Number(vm.appointmentAnticipationHoursValue) : 0,
                vm.appointmentLimitDays = vm.appointmentLimitDaysValue ? Number(vm.appointmentLimitDaysValue) : 14
            },
            getScheduleConfig(){
                var vm = this
                return {
                    week_days: vm.weekDays,
                    interval_minutes: vm.intervalMinutes,
                    interval_start: vm.intervalStart,
                    interval_end: vm.intervalEnd,
                    interval_count: vm.intervalCount,
                    appointment_anticipation_hours: vm.appointmentAnticipationHours,
                    appointment_limit_days: vm.appointmentLimitDays,
                    name: vm.name
                }
            }
        },
        data(){
            return {
                scheduleStructureChanged: false,
                weekDays: [],
                name: '',
                intervalMinutes: 60,
                intervalStart: '',
                intervalEnd: '',
                appointmentAnticipationHours: 24,
                appointmentLimitDays: 7
            }
        },
        computed:{
          scheduleStructureChangeWarning(){
            const vm = this
            return !!(vm.isUpdate && vm.scheduleStructureChanged)
          },
          isValid(){
            const vm = this
            const config = vm.getScheduleConfig()

            return (!(
                !config.week_days ||
                !config.interval_minutes ||
                !config.interval_start ||
                !config.interval_end ||
                !config.interval_count
            ) || vm.scheduleLengthError)
          },
          scheduleLengthError(){
            const vm = this
            if(vm.appointmentAnticipationHours === 72 && vm.appointmentLimitDays === 3){
              return 'Si la anticipación de la cita es igual a la cantidad de días disponibles, no habrían horas para elegir'
            }

            return ''

          },
          appointmentAnticipationOptions(){
            return [
              {
                text: 'Sin anticipación',
                value: 0
              },
              {
                text: '1 hora',
                value: 1
              },
              {
                text: '2 horas',
                value: 2
              },
              {
                text: '3 horas',
                value: 3
              },
              {
                text: '6 horas',
                value: 6
              },
              {
                text: '12 horas',
                value: 12
              },
              {
                text: '1 día',
                value: 24
              },
              {
                text: '2 días',
                value: 48
              },
              {
                text: '3 días',
                value: 72
              },
            ]
          },
          appointmentLimitDaysOptions(){
            return [
              {
                text: '3 días',
                value: 3
              },
              {
                text: '1 semana',
                value: 7
              },
              {
                text: '2 semanas',
                value: 14
              },
              {
                text: '1 mes',
                value: 30
              }
            ]
          },
          intervalOptions(){
            return [
              {
                text: '5 minutos',
                value: 5
              },
              {
                text: '10 minutos',
                value: 10
              },
              {
                text: '15 minutos',
                value: 15
              },
              {
                text: '20 minutos',
                value: 20
              },
              {
                text: '25 minutos',
                value: 25
              },
              {
                text: '30 minutos',
                value: 30
              },
              {
                text: '45 minutos',
                value: 45
              },
              {
                text: '1 hora',
                value: 60
              },
              {
                text: '2 horas',
                value: 120
              }
            ]
          },
            intervals(){
                var vm = this
                var options = []
                var startTime = vm.$moment().startOf('day')
                var endTime = vm.$moment().endOf('day')

                while(startTime.isSameOrBefore(endTime)){
                    options.push(startTime.format('HH:mm'))
                    startTime.add(vm.intervalMinutes, 'minutes')
                }

                return options
            },
            intervalCount(){
                var vm = this
                var blocksNumber = 0
                var startTime = vm.$moment(vm.intervalStart, 'HH:mm')
                var endTime = vm.$moment(vm.intervalEnd, 'HH:mm')

                while(startTime.isSameOrBefore(endTime)){
                    blocksNumber++
                    startTime.add(vm.intervalMinutes, 'minutes')
                }

                return blocksNumber
            }
        },
        watch:{
            weekDays(){
              const vm = this
              vm.scheduleStructureChanged = true
            },
            intervalMinutes(val){
                var vm = this
                vm.scheduleStructureChanged = true
                if(!vm.intervals.find(interval => interval === vm.intervalStart)){
                    vm.intervalStart = vm.intervals[0]
                }

                if(!vm.intervals.find(interval => interval === vm.intervalEnd)){
                    vm.intervalEnd = vm.intervals[vm.intervals.length-1]
                }
            },
            intervalStart(val, old){
                var vm = this
                vm.scheduleStructureChanged = true
                if(!vm.intervalEnd) return
                if(vm.$moment(val, 'HH:mm').isSameOrAfter(vm.$moment(vm.intervalEnd, 'HH:mm'))){
                    vm.showSnackBar('El inicio de jornada debe ser menor al término')
                    vm.$nextTick(function(){
                        vm.intervalStart = old || vm.intervals[0]
                    })
                }
            },
            intervalEnd(val, old){
                var vm = this
                vm.scheduleStructureChanged = true
                if(!vm.intervalStart) return
                if(vm.$moment(val, 'HH:mm').isSameOrBefore(vm.$moment(vm.intervalStart, 'HH:mm'))){
                    vm.showSnackBar('El término de jornada debe ser mayor al inicio')
                    vm.$nextTick(function(){
                        vm.intervalEnd = old || vm.intervals[vm.intervals.length-1]
                    })
                }
            },
            nameValue(val){
                var vm = this
                vm.name =  val
            },
            intervalMinutesValue(val){
                var vm = this
                vm.scheduleStructureChanged = true
                vm.intervalMinutes = val ? Number(val) : 20
            },
            intervalStartValue(val){
                var vm = this
                vm.intervalStart = val
            },
            intervalEndValue(val){
                var vm = this
                vm.intervalEnd = val
            },
            weekDaysValue(val){
                var vm = this
                vm.weekDays = val
            },
            appointmentAnticipationHoursValue(val){
                var vm = this
                vm.appointmentAnticipationHours = val
            },
            appointmentLimitDaysValue(val){
                var vm = this
                vm.appointmentLimitDays = val
            }
        }
    }
</script>
